<template>
  <div class="tab_box">
    <vxe-table
      border
      resizable 
      ref="editTabList"
      :data="this.$store.state.cache.backflush.details"
      :edit-config="{trigger: 'click', mode: 'cell',activeMethod: activeCellMethod}"
      @edit-actived="editActivedEvent"
      @edit-closed="editClosedEvent"
      @edit-disabled="editDisabledEvent"
    >
      <vxe-table-column type="checkbox" width="40"></vxe-table-column>
      <vxe-table-column
        field="bomProjectNo"
        title="项目"
        width="90"
      ></vxe-table-column>
      <vxe-table-column
        field="projectClassify"
        title="项目类别"
        width="120"
      ></vxe-table-column>
      <vxe-table-column
        field="materialCode"
        title="组件"
        width="90"
      ></vxe-table-column>
      <vxe-table-column
        field="materialDesc"
        title="组件描述"
        width="120"
      ></vxe-table-column>
      <vxe-table-column
        field="outboundNum"
        title="订单出库数量"
        :edit-render="{name: 'input', attrs: {type: 'number'},events:{change:changOutboundNum}}"
        width="120"
      ></vxe-table-column>
      <vxe-table-column
        field="componentRecoilNum"
        title="反冲数量"
        :edit-render="{name: 'input', attrs: {type: 'number'},events:{change:changCompRecoilNum}}"
        width="120"
      ></vxe-table-column>
      <vxe-table-column
        field="entryUnitDesc"
        title="计量单位"
        :edit-render="{name: 'select', options: targetUnitList,events:{change:changEvent}}"
        width="120"
      ></vxe-table-column>
      <vxe-table-column
        field="inventoryDesc"
        title="库存地点"
        width="120"
      ></vxe-table-column>
      <vxe-table-column
        field="component"
        title="组装件"
        width="120"
      ></vxe-table-column>
      <vxe-table-column field="deletedItem" title="删除标志" width="120"></vxe-table-column>
      <vxe-table-column field="recoil" title="反冲标识" width="120"></vxe-table-column>
    </vxe-table>
    <div class="coll list_content">
      <h2 class="title">
        <span>备注</span>
      </h2>
      <el-input type="textarea" :rows="2" placeholder="暂无备注" v-model="projectTxt"></el-input>
    </div>
  </div>
</template>
<script>
import { excelUpload, excelDownload } from "api/excel.js";
import { targetUnit } from "api/business.js";
import { mapState, mapActions } from "vuex";
export default {
  components: {
  },
  props: {
    // fromData: Object,
    // noFromData: Object
  },
  computed: {
    
  },
  data() {
    return {
      targetUnitList: [],
      projectTxt: "",
    };
  },
  async created() {
    let targetUnitList = await this.$post(
      targetUnit.list,
      this.$store.state.getAllPage
    );
    console.log(targetUnitList, "8888888888");
    if (targetUnitList.status) {
      this.targetUnitList = targetUnitList.data.list;
      this.targetUnitList.forEach(item => {
        item.label = item.unitDesc;
        item.value = item.unitDesc;
      });
    }
    console.log(this.$store.state.cache.backflushList)
  },
  mounted: function() {
    this.$nextTick(function() {});
  },
  updated: function() {},
  methods: {
    editActivedEvent({ row, column }, event) {
      console.log(`打开 ${column.title} 列编辑`);
    },
    editClosedEvent({ row, column }, event) {
      console.log(`关闭 ${column.title} 列编辑`);
    },

    ...mapActions("cache", ["setSelectedProductOrderMaterials"]),
    
    //计量单位改变
    changEvent({ row }, event) {
      console.log(event.target.value, "===13123231===", this.targetUnitList);
      let obj = this.targetUnitList.find(v => v.unitDesc == event.target.value);
      console.log(obj);
      row.basicUnitId = obj.unitId;
      row.basicUnitCode = obj.unitCode;
      row.basicUnitDesc = obj.unitDesc;

      //alert(1);
      console.log(row, "===  666666666 ==", event);
    },
    //订单出库数量改变
    changOutboundNum(val){
      console.log(val.data)
      this.$store.state.cache.backflush.details = val.data
    },
    //反冲数量改变
    changCompRecoilNum(val){
      console.log(val.data)
      this.$store.state.cache.backflush.details = val.data
    },
    activeCellMethod({ column, columnIndex }) {
      if (columnIndex === 6) {
        return true;
      } 
      return false;
    },
    editDisabledEvent({ row, column }) {
      // this.$message.error("禁止编辑");
    },
  }
};
</script>

<style>
</style>
